import { render, staticRenderFns } from "./StandeeAddPriceModel.vue?vue&type=template&id=6996c799&"
import script from "./StandeeAddPriceModel.ts?vue&type=script&lang=js&"
export * from "./StandeeAddPriceModel.ts?vue&type=script&lang=js&"
import style0 from "./StandeeAddPriceModel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports